import { P } from '@workramp/ui';
import styled from 'styled-components';

export const PermissionContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const PermissionDetailsContainer = styled.div`
  display: flex;
`;

export const PermissionNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: ${({ theme }) => theme.spacing(2)}px;
`;

export const PermissionEmail = styled(P)`
  color: ${({ theme }) => theme.colors.on[400]};
`;
